import APIClient from '@/shared/http/clients/api'

const resourceName = 'cardproduto'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=posicao,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (cardId = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?cardId=${cardId}&page=${index}&size=${limit}`, config)
const SearchBySituacao = (cardId = {}, situacao = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?cardId=${cardId}&situacao=${situacao}&page=${index}&size=${limit}`, config)
const ChangeStatus = (id, data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${id}/`, data, config)
const SearchOperations = ({ cpf, operation }, config = {}) =>
  APIClient.get(`${APICore}/${resourceName}/search-operations`, {
    params: {
      ...(cpf && { cpf }),
      ...(operation && { operation })
    },
    ...config
  })

const CardProductRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  ChangeStatus,
  SearchOperations,
  SearchBySituacao
}

export default CardProductRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/cardproduct.js